const classPrefix = 'modal-info'
const dataPrefix = 'data-modal-info'


export function modalInfo($container) {

    const $template = document.querySelector(`[${dataPrefix}-template]`)

    if ($template){
        init()
    }


    function init(){
        const $modalClone = document.importNode($template.content, true)
        $container.appendChild($modalClone)
    }
}




